module.exports = __webpack_public_path__ + "img/25_60.2fe3329c.png";